export const previewIngredients = [
  { _id: 'i1', name: 'Tomates cherry', standardUnit: 'gramos', subcategoria: 'Fruta y verdura' },
  { _id: 'i2', name: 'Espinacas frescas', standardUnit: 'gramos', subcategoria: 'Fruta y verdura' },
  { _id: 'i3', name: 'Pechuga de pollo', standardUnit: 'gramos', subcategoria: 'Carnicería' },
  { _id: 'i4', name: 'Yogur griego', standardUnit: 'unidades', gramsPerUnit: 125, subcategoria: 'Lácteos' },
  { _id: 'i5', name: 'Arroz integral', standardUnit: 'gramos', subcategoria: 'Despensa' },
  { _id: 'i6', name: 'Aguacates', standardUnit: 'unidades', gramsPerUnit: 180, subcategoria: 'Fruta y verdura' },
];

export const previewLists = [
  {
    _id: 'semana-actual', nombre: 'Compra · semana del 15 de julio', createdAt: '2026-07-12T09:00:00.000Z', archived: false,
    ingredientes: [
      { idIngrediente: 'i1', cantidad: 500, unit: 'gramos', estado: 'comprado' },
      { idIngrediente: 'i2', cantidad: 300, unit: 'gramos', estado: 'pendiente' },
      { idIngrediente: 'i3', cantidad: 800, unit: 'gramos', estado: 'comprado' },
      { idIngrediente: 'i4', cantidad: 4, unit: 'unidades', estado: 'pendiente' },
      { idIngrediente: 'i5', cantidad: 450, unit: 'gramos', estado: 'pendiente' },
      { idIngrediente: 'i6', cantidad: 3, unit: 'unidades', estado: 'pendiente' },
    ],
  },
  {
    _id: 'finde', nombre: 'Cena con amigos', createdAt: '2026-07-10T16:30:00.000Z', archived: false,
    ingredientes: [
      { idIngrediente: 'i1', cantidad: 300, unit: 'gramos', estado: 'comprado' },
      { idIngrediente: 'i3', cantidad: 1200, unit: 'gramos', estado: 'comprado' },
      { idIngrediente: 'i6', cantidad: 4, unit: 'unidades', estado: 'comprado' },
    ],
  },
  {
    _id: 'junio', nombre: 'Compra · última semana de junio', createdAt: '2026-06-24T11:00:00.000Z', archived: true,
    ingredientes: previewIngredients.slice(0, 5).map((ingredient) => ({ idIngrediente: ingredient._id, cantidad: 2, unit: ingredient.standardUnit, estado: 'comprado' })),
  },
];
